import { List } from "immutable";

import QuizzesOnlySpec from "seneca-common/features/assignments/state/models/spec/QuizzesOnlySpec";

export function getQuizIds(spec: QuizzesOnlySpec): List<string> {
  return spec.quizzes.keySeq().toList();
}
